import { render, staticRenderFns } from "./TitleComponent.vue?vue&type=template&id=6b2c86ee&scoped=true&"
import script from "./TitleComponent.vue?vue&type=script&lang=js&"
export * from "./TitleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c86ee",
  null
  
)

export default component.exports